import { DynamicModule } from '@nestjs/common';
import { FileStorageRepositoryWebModule } from '@module/file-storage';
import { noAuthUseCaseProviders, useCaseProviders } from './usecase-providers';
import { authenticationUseCaseProviders } from './usecase-providers/authentication.provider';
import { AssignmentRepositoryWebModule } from '@module/assignment';
import { FormReleaseRepositoryWebModule, FormRepositoryWebModule } from '@module/form';
import { IdentityRepositoryWebModule } from '@module/user';
import { ReportRepositoryWebModule } from '@module/report';
import { AIWebModule } from '@module/ai';
import { billingDataProviders } from '@module/ai-chat-app';
import { ClassRepositoryWebModule, ClassStudentProgressWebModule } from '@module/class';

export type TestMakerApplicationConfig = {
  accessToken?: string;
  formBaseUrl?: string;
  assignmentBaseUrl?: string;
  classBaseUrl?: string;
  fileStorageBaseUrl?: string;
  reportBaseUrl?: string;
  userBaseUrl?: string;
  aiBaseUrl?: string;
  accountingBaseUrl?: string;
  appSyncConfig: {
    url: string;
    apiKey: string;
  };
  timeout?: number;
};

export class ApplicationModule {
  public static register(config: TestMakerApplicationConfig): DynamicModule {
    const {
      accessToken,
      formBaseUrl,
      assignmentBaseUrl,
      classBaseUrl,
      fileStorageBaseUrl,
      reportBaseUrl,
      userBaseUrl,
      aiBaseUrl,
      accountingBaseUrl,
      appSyncConfig,
      timeout,
    } = config;
    return {
      module: ApplicationModule,
      imports: [
        AssignmentRepositoryWebModule.register(
          {
            accessToken,
            baseUrl: assignmentBaseUrl,
            timeout,
          },
          {
            accessToken,
            baseUrl: formBaseUrl,
            timeout,
          },
        ),
        ClassRepositoryWebModule.register({
          accessToken,
          baseUrl: classBaseUrl,
          timeout,
        }),
        ClassStudentProgressWebModule.register({
          accessToken,
          classBaseUrl,
          assignmentBaseUrl,
          timeout,
        }),
        FormRepositoryWebModule.register({
          accessToken,
          baseUrl: formBaseUrl,
          timeout,
        }),
        FormReleaseRepositoryWebModule.register({
          accessToken,
          baseUrl: formBaseUrl,
          timeout,
        }),
        IdentityRepositoryWebModule.register({
          accessToken,
          baseUrl: userBaseUrl,
          timeout,
        }),
        FileStorageRepositoryWebModule.register({
          accessToken,
          baseUrl: fileStorageBaseUrl,
          timeout,
        }),
        ReportRepositoryWebModule.register({
          accessToken,
          baseUrl: reportBaseUrl,
          timeout,
        }),
        AIWebModule.register({
          accessToken,
          baseUrl: aiBaseUrl,
          accountingBaseUrl,
          appSyncUrl: appSyncConfig.url,
          appSyncApiKey: appSyncConfig.apiKey,
          timeout,
        }),
      ],
      providers: [
        ...billingDataProviders,
        ...noAuthUseCaseProviders,
        ...useCaseProviders,
        ...authenticationUseCaseProviders,
      ],
      exports: [...useCaseProviders, ...authenticationUseCaseProviders, ...noAuthUseCaseProviders],
    };
  }
}
